import React, { Component } from "react";
import { setLoader } from "../../redux/actions";
import {
  Form,
  FormGroup,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Collapse,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import CustomModal from "./CustomModal";
import { connect } from "react-redux";
import { Colxx } from "../../components/common/CustomBootstrap";
import Field from "../../components/utils/Field";
import FormSmart from "../../components/utils/FormSmart";
import SimpleReactValidator from 'simple-react-validator';
import CrudGrid from "../../views/app/modules/crudGrid";
import es from 'simple-react-validator/dist/locale/es';
import { Wizard, Steps, Step } from 'react-albus';
import TopNavigation from '../../components/utils/wizard/TopNavigation';
import AppLocale from "../../config/lang";
import { cloneDeep } from "lodash"
import AiAssist from "./AiAssist";

class FormCustom extends Component {
  constructor(props) {
    // console.log(props)
    super(props);
    SimpleReactValidator.addLocale('es', es)
    this.validator = new SimpleReactValidator(
      {
        locale: this.props.locale,
        validators: {
          ext: {
            message: 'Solo se permiten los siguientes tipos de archivos: :values.',
            rule: (val, params, validator) => {
              if (Array.isArray(val)) {
                const file = val[0].ext.toLowerCase()
                return params.indexOf(file) > -1
              } else return true // si es solo un string (nombre de la imagen sin extensión)
            },
            messageReplace: (message, params) => {
              return message.replace(':values', params.join()) // optional
            }
          }
        },
        messages: {
          required: this.props.locale === 'en' ? 'The :attribute field is required.' : 'El campo :attribute es requerido.',
          email: this.props.locale === 'en' ? 'The :attribute must be a valid email address.' : 'El campo :attribute no es un correo válido',
          max: this.props.locale === 'en' ? 'The :attribute may not be greater than :max characters.' : ':attribute no debe ser mayor a :max caracteres.',
          min: this.props.locale === 'en' ? 'The :attribute must be at least :min characters.' : ':attribute no debe ser menor a :min caracteres.'
        }
      }
    );

    this.validator.helpers.humanizeFieldName = function humanizeFieldName(field) {
      // supports snake_case or camelCase
      return field.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ');
    }

    this.validator.helpers.message = function (rule, field, options, rules) {
      options.messages = options.messages || {};
      var message = options.messages[rule] || options.messages.default || this.parent.messages[rule] || this.parent.messages.default || rules[rule].message;
      return message.replace(':attribute', this.humanizeFieldName(field.split("_")[1]?? field));
    }

    this.validateForm = this.validateForm.bind(this)
    
    var s = {}

    if (props.flags) s.flags = props.flags

    if (props.edit) s.edit = props.edit

    if (props.subforms?.length > 0) {
      if (!s.flags) s.flags = {}
      props.subforms.forEach((e, i) => {
        s.flags['subformOpen' + i] = false
      });
    }

    if (props.subGrids?.length > 0) {
      if (!s.flags) s.flags = {}
      props.subGrids.forEach((e, i) => {
        s.flags['subGridOpen' + i] = false
      });
    }

    if (props.fields?.length > 0) {
      let c = props.fields.filter(e => e.type === 'collapsible')
      if (c.length > 0) {
        if (!s.flags) s.flags = {}
        c.forEach(e => {
          s.flags[e.name] = e.value
          e.childs.forEach(ee => s[ee.name] = ee.value);
        });
      }

      let w = props.fields.find(e => e.type === 'wizard')
      if (w) {
        if (!s.flags) s.flags = {}
        s.flags.currentStepId = w.steps.length > 0 ? w.steps.filter(step => step.renderIf ? step.renderIf() : true)[0].id : null
        s.flags.currentStepIndex = 0
        s.flags.stepsLength = w.steps?.filter(step => step.renderIf ? step.renderIf() : true)
        s.flags.bottomNavHidden = false
        s.flags.topNavDisabled = false
        w.steps.forEach(step => {
          step.fields.forEach(field => {
            s[field.name] = field.value
            if (field.childs) field.childs.forEach(c => { s[c.name] = c.value })
          })
        });
      }

      let t = props.fields.find(e => e.type === 'tabs')
      if (t) {
        if (!s.flags) s.flags = {}
        s.flags.activeTab = t.value?? (t.tabs.length > 0 ? t.tabs[0].id : "")
        t.tabs.forEach(tab => {
          tab.fields.forEach(field => {
            s[field.name] = field.value
          })
        });
      }
    }

    if (props.fields) props.fields.forEach(e => { if(['tabs', 'collapsible', 'wizard', 'separator'].indexOf(e.type) === -1) s[e.name] = e.value })
 
    s.selectedField = null
    this.state = s
    this.defaultValuesForm = cloneDeep(this.state)

    this.wizardRef = React.createRef()
    this.aiAssistRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.listenStates) this.props.listenStates(this.state)
    if (this.props.validate) this.props.validate(this.validateForm)
    if (this.props.validateFor) this.props.validateFor(this.validateFor)
    if (this.props.nextStep) this.props.nextStep(this.nextStep)
    if (this.props.resetForm) this.props.resetForm(this.resetForm)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.didUpdateStates) {
      const { fields } = this.props
      const { fields: prevFields } = prevProps
      if (fields !== prevFields) {
        fields.forEach(field => {
          if(['tabs', 'collapsible', 'wizard', 'separator'].indexOf(field.type) === -1) this.setState({ [field.name]: field.value })
          if (field.type === 'wizard') {
            field.steps.forEach(step => {
              step.fields.forEach(f => {
                this.setState({ [f.name]: f.value })
              })
            })
          }
        })
      }
    }
    
    if (this.state !== prevState) {
      if (this.props.listenStates) this.props.listenStates(this.state)
    }

    if (!this.state.edit) {
      // si exiten fields que dependen de otros
      let flatFields = cloneDeep(this.props.fields)
      let wizard = flatFields.find(f => f.type === "wizard")
      if (wizard) {
        wizard.steps.forEach(step => {
          flatFields = flatFields.concat(step.fields)
        })
      }

      flatFields.filter(e => e.parent).forEach((ee) => {
        if (prevState[ee.parent] !== this.state[ee.parent]) this.setState({ [ee.name]: null })
      })
    }

    if (this.state.edit) {
      setTimeout(() => { this.setState({edit: false}) }, 500)
    }
  }

  resetForm = () => {
    this.setState(this.defaultValuesForm)
  }

  labelForValidator  = (f, L) => {
    return `${f.name}_${typeof f.label === 'function' ? f.label(L, this.state) : L[f.label]?? f.label?? ''}`
  }

  btnAction(action) {
    if (this.props.listenBtnActions) this.props.listenBtnActions(action, this.state)
  }

  showTooltip(field) {
    if (this.props.listenBtnActions) this.props.listenBtnActions('tooltip', field); // when used from FormCustom
    if (this.props.onTooltip) this.props.onTooltip(field); // when used from FormSmart
  }

  validateForm = () => {
    return new Promise((resolve, reject) => {
      const wizard = this.props.fields.find(f => f.type === "wizard")
      if (this.validator.allValid() && !wizard) {
        resolve(true)
      } else {
        // console.log(this.validator)
        this.validator.showMessages();
        this.forceUpdate();
  
        const { locale } = this.props
        const L = AppLocale[locale].messages
  
        // open collapsible if fields have invalid data
        let collapsibles = this.props.fields.filter(f => f.type === "collapsible")
        for(const c of collapsibles) {
          let m = c.childs.find(f => this.validator.fields[this.labelForValidator(f, L)] === false)
          if (m) {
            this.toggleCollapsible(c.name, true)
            break
          }
        }
  
        // scroll and focus in input required
        let fields = this.props.fields
        fields = fields.concat(this.props.fields.flatMap(f => f.childs || [])) // for collapsibles fields
        fields = fields.concat(this.props.fields.flatMap(w => w.steps || []).flatMap(f => f.fields || [])) // for step fields
        let field = fields.find(f => this.validator.fields[this.labelForValidator(f, L)] === false)
        if (field) {
          const id = field.id?? `${this.props.id}-${field.name}`
          const fieldId = document.getElementById(id)
          if (fieldId) {
            fieldId.scrollIntoView()
            fieldId.focus()
          }
        }

        // validate by step
        if (wizard) {
          let fieldsCurrentStep = wizard.steps.find(s => s.id === this.wizardRef.current.state.step.id).fields
          const invalidStep = fieldsCurrentStep.some(f => this.validator.fields[`${f.name}_${L[f.label]?? f.label}`] === false)
          if (invalidStep) reject(false)
          else {
            if (wizard.saveByStep || this.props.edit) resolve(true)
            else {
              if ((this.wizardRef.current.state.steps.length - 1) === this.state.flags.currentStepIndex) resolve(true)
              else this.nextStep()
            }
          }
        }

        reject(false)
      }
    })
  }

  validateFor = (fieldName, requiredFields) => {
    return new Promise((resolve, reject) => {
      const { locale } = this.props
      const L = AppLocale[locale].messages
      const keysValues = {}
      let scrollToField = null
      this.validator.visibleFields = []
      this.validator.hideMessages()
      this.forceUpdate()
      let fields = this.props.fields
      fields = fields.concat(this.props.fields.flatMap(f => f.childs || [])) // for collapsibles fields
      fields = fields.concat(this.props.fields.flatMap(w => w.steps || []).flatMap(f => f.fields || [])) // for step fields
      const field = fields.find(f => f.name === fieldName)
      if (field) this.validator.hideMessageFor(`${field.name}_${L[field.label]}`)

      if (!requiredFields || requiredFields.length === 0) resolve({})

      requiredFields.forEach(r => {
        const field = fields.find(f => f.name === r)
        if (field) {
          const name = this.labelForValidator(field, L)
          this.validator.message(name, this.state[field.name], field.rules?? 'required')
          this.forceUpdate()
          if (!this.validator.fieldValid(name)) {
            const id = field.id?? `${this.props.id}-${field.name}`
            if(!scrollToField) scrollToField = id
            this.validator.showMessageFor(name)
            this.forceUpdate()
          } else {
            Object.assign(keysValues, { [field.name]: this.state[field.name] })
          }
        }
      })

      const fieldId = document.getElementById(scrollToField)
      if (fieldId) {
        fieldId.scrollIntoView()
        fieldId.focus()
      }
  
      if (Object.keys(keysValues).length === requiredFields.length) resolve(keysValues)
      else reject(keysValues)
    })
  }

  toogleSubForm = (index) => {
    let flags = { ...this.state.flags }
    flags['subformOpen' + index] = !flags['subformOpen' + index]
    this.setState({ flags }, () => {
      if (this.props.subforms && this.props.subforms[index] && this.props.subforms[index].listenToogleSubform) this.props.subforms[index].listenToogleSubform(flags['subformOpen' + index])
    })
  }

  toogleSubGrid(index) {
    let flags = { ...this.state.flags }
    flags['subGridOpen' + index] = !flags['subGridOpen' + index]
    this.setState({ flags })
  }

  toggleCollapsible(collapsible, open) {
    const prevState = this.state.flags;
    this.props.fields.forEach(e => { if (e.type === 'collapsible' && e.name !== collapsible) prevState[e.name] = false });
    prevState[collapsible] = open || !prevState[collapsible]
    this.setState({ flags: prevState });
  }

  // Wizard ------------------------------
  setCurrentStep = (index, id) => {
    let flags = this.state.flags
    flags.currentStepIndex = index
    flags.currentStepId = id
    this.setState({flags: flags}, () => {
      const w = this.props.fields.find(e => e.type === 'wizard')
      if (w.onChange) w.onChange(id)
    })
  }

  nextStep = () => {
    return new Promise((resolve, reject) => {
      if (!this.wizardRef?.current) {
        return reject(new Error("wizardRef.current is not available"))
      }

      this.wizardRef.current.next()
      this.validator.hideMessages()
      
      process.nextTick(() => {
        try {
          const currentStepId = this.wizardRef.current.state.step.id
          const currentStepIndex = this.wizardRef.current.state.steps.findIndex(s => s.id === currentStepId)
          this.setCurrentStep(currentStepIndex, currentStepId)
          resolve({index: currentStepIndex, id: currentStepId})
        } catch (error) {
          reject(error)
        }
      })
    })
  }

  topNavClick = (stepItem, push) => {
    this.validator.hideMessages()
    const currentStepIndex = this.wizardRef.current.state.steps.findIndex(s => s.id === stepItem.id)
    this.setCurrentStep(currentStepIndex, stepItem.id)
    if (this.state.flags.topNavDisabled) return
    push(stepItem.id)
  }
  // End Wizard ------------------------------

  createButtons = (wrapButtonsWithDiv, buttons, L) => {
    return buttons.map(b => {
      const btn = <FormGroup className={b.isMain ? 'text-right' : ''}>
        <Button
          type="button"
          color={b.disabled === false || (!b.disabled && !b.isMain) ? 'primary' : 'disabled'}
          disabled={!(b.disabled === false || (!b.disabled && !b.isMain))}
          onClick={b.onClick ? () => { b.onClick(this) } : () => { }}
          outline={!!b.opts?.outline}
        >
          <i className={b.icon}></i> {typeof b.label === 'function' ? b.label(L) : L[b.label]?? b.label}
        </Button>
      </FormGroup>
      const wrap = wrapButtonsWithDiv ? <div className="ml-2" key={b.label}>{btn}</div> : <Colxx sm={b.col} key={b.label}>{btn}</Colxx>
      return (
        (b.renderIf ? b.renderIf(this) : true) && wrap
      )
    })
  }

  handleClickAiAssist = (field, editor) => {
    if (editor) this.editor = editor
    this.setState({selectedField: field}, () => {
      this.aiAssistRef.current.execute()
    })
  }

  setActiveTab = (id) => {
    this.validator.hideMessages()
    this.resetForm()
    this.setState({flags: {...this.state.flags, ...{activeTab: id}}})
  }

  render() {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    this.validator.purgeFields();
    const p = this.props
    const detailGrid = p.detailGrid ? p.detailGrid(this) : null
    return (
      <div>
        {(p.fields || p.buttons) &&
          <Form autoComplete="off">
            <FormGroup row>
              {p.fields && p.fields.map((field, i) => {
                const createField = (c) => {
                  const create = (f) => {
                    let disabled = typeof f.disabled === 'function' ? f.disabled(this) : f.disabled
                    return <Field
                      id={f.id}
                      idParent={p.id}
                      key={f.type === "radio" ? `${f.name}-${f.opts.value}` : f.name}
                      col={f.col}
                      offset={f.offset}
                      colxs={f.colxs}
                      name={f.name}
                      type={f.type}
                      // value={this.state[f.name]}
                      value={typeof this.state[f.name] === "function" ? this.state[f.name](L, this.state) : this.state[f.name]}
                      label={typeof f.label === "function" ? f.label(L, this.state) : L[f.label]?? f.label}
                      placeholder={L[f.placeholder]?? f.placeholder}
                      hint={L[f.hint]?? f.hint}
                      opts={f.opts}
                      disabled={disabled}
                      maxLength={f.maxLength}
                      validate={(typeof f.rules === "function" ? f.rules() : f.rules) && !disabled ? this.validator.message(`${f.name}_${typeof f.label === "function" ? f.label(L, this.state) : L[f.label]?? f.label?? ''}`, this.state[f.name], (typeof f.rules === "function" ? f.rules() : f.rules), f.rulesMessages || {}) : ""}
                      onChange={(n) => { this.setState({ [f.name]: n }, () => { if (f.onChange) f.onChange(this) }) }}
                      onKeyPress={f.onKeyPress}
                      onFocus={f.onFocus}
                      onClick={f.onClick ? () => { f.onClick(this) } : () => { }}
                      onTooltip={e => this.showTooltip(e)}
                      uploadFiles={f.type === "dropzone" ? p.uploadFiles : null}
                      parentValue={f.parent ? this.state[f.parent] : null}
                      className={f.classNameF ? f.classNameF(this) : f.className}
                      ctx={this}
                      checked={f.type === "radio" ? (this.state[f.name] === f.opts.value) : false}
                      locale={p.locale}
                      aiAssist={f.aiAssist}
                      onClickAiAssist={this.handleClickAiAssist}
                      autoComplete={f.autoComplete}
                      clearable={f.clearable}
                      getValueLabelOfFieldSelect={this.props.getValueLabelOfFieldSelect && f.type === "select" ? this.props.getValueLabelOfFieldSelect : null}
                    />
                  }
                  if (c.type === 'collapsible')
                  {
                    return <Colxx sm={c.col} key={`collapsible-${i}`}>
                      <FormGroup>
                        <div className={'cs-content-collapse ' + (this.state.flags[c.name] ? 'active' : '')}>
                          <Button
                            className="cs-collapse-header"
                            color="link"
                            onClick={() => this.toggleCollapsible(c.name)}
                            aria-expanded={this.state.flags[c.name]}
                          >
                            <span>{L[c.label]?? c.label}</span>
                            {L[c.placeholder??"main.clickToExpand"]}
                          </Button>
                          <Collapse isOpen={this.state.flags[c.name]}>
                            <div className="m-3">
                              <FormGroup row>
                                {c.childs &&  c.childs.map(child => {
                                  return (
                                    (child.renderIf ? child.renderIf(this) : true) && create(child)
                                  );
                                })}
                              </FormGroup>
                            </div>
                          </Collapse>
                        </div>
                      </FormGroup>
                    </Colxx>
                  }
                  else if (c.type === 'wizard') 
                  {
                    // const cs = c.steps.find(e => e.id === this.state.flags.currentStepId)
                    return <Colxx sm={c.col} key={`wizard-${i}`}>
                      <Card key={"wrapWizard"} className={"custom-card"}>
                        {/* <span className="font-weight-bold text-center color-theme-1">{L[cs.name]?? cs.name}</span>
                        <small className="text-center color-theme-1">{L[cs.desc]?? cs.desc}</small> */}
                        <CardBody className="wizard wizard-default">
                          <Wizard ref={this.wizardRef}>
                            <TopNavigation
                              className="justify-content-center"
                              disableNav={!p.edit}
                              topNavClick={this.topNavClick}
                            />
                            <Steps>
                              {c.steps.filter(step => step.renderIf ? step.renderIf() : true).map((s, i) => {
                                return (
                                <Step
                                  id={s.id}
                                  name={L[s.name]?? s.name}
                                  desc={"" /*L[s.desc]?? s.desc */}
                                  key={`step${i}`}  
                                >
                                  <div className="wizard-basic-step">
                                    {this.state.flags.currentStepId === s.id &&
                                      <FormGroup row>
                                        {s.fields.map(f => {
                                          const doField = ["fieldset", "collapsible"].includes(f.type) ? createField : create
                                          return (
                                            (f.renderIf ? f.renderIf(this) : true) && doField(f)
                                          );
                                        })}
                                      </FormGroup>
                                    }
                                  </div>
                                </Step>
                                )
                              })}
                            </Steps>
                          </Wizard>
                        </CardBody>
                      </Card>
                    </Colxx>
                  }
                  else if (c.type === 'tabs') 
                    {
                      return <Colxx sm={c.col} key={`tab-${i}`}>
                        <Nav tabs className="separator-tabs ml-0 mb-5" key={`separator${i}`}>
                          {c.tabs.map((t, i) => {
                            return (
                              <NavItem key={`navItem${i}`}>
                                <NavLink
                                  to={`#`}
                                  className={`nav-link ${this.state.flags.activeTab === t.id ? "active" : ""}`}
                                  onClick={() => this.setActiveTab(t.id)}
                                  key={`tab${i}`}
                                >
                                  {L[t.name]?? t.name}
                                </NavLink>
                              </NavItem>
                            )}
                          )}
                        </Nav>
                        <TabContent activeTab={this.state.flags.activeTab} key={`tabContent${i}`}>
                          {c.tabs.map((t, i) => {
                            return (
                              <TabPane tabId={t.id} key={`tabPane${i}`}>
                                {this.state.flags.activeTab === t.id &&
                                  <FormGroup row>
                                    {t.fields.map(f => {
                                      return (
                                        (f.renderIf ? f.renderIf(this) : true) && create(f)
                                      );
                                    })}
                                  </FormGroup>
                                }
                              </TabPane>
                            )}
                          )}
                        </TabContent>
                      </Colxx>
                  }
                  else if (c.type === 'fieldset')
                  {
                    return <Colxx sm={c.col} key={`fieldset-${i}`}>
                      <FormGroup row>
                        {c.childs?.map(f => {
                          return (
                            (f.renderIf ? f.renderIf(this) : true) && create(f)
                          )
                        })}
                      </FormGroup>
                    </Colxx>
                  }
                  else return create(c)
                }
                return (
                  (field.renderIf ? field.renderIf(this) : true) && createField(field)
                );
              })}

              {p.wrapButtonsWithDiv && p.buttons && <div className="mt-2 px-3 w-100 d-flex justify-content-end">{this.createButtons(p.wrapButtonsWithDiv, p.buttons, L)}</div>}
              {!p.wrapButtonsWithDiv && p.buttons && this.createButtons(false, p.buttons, L)}
            </FormGroup>
          </Form>
        }

        {detailGrid && (detailGrid.renderIf ? detailGrid.renderIf(this) : true)  &&
          <div id="detailGrid">
            <CrudGrid
              module={detailGrid.module}
              config={detailGrid.config}
              embeded={detailGrid.embeded}
              match={{ path: '/app/' + detailGrid.module }}
              parentId={detailGrid.parentIdField ? this.state[detailGrid.parentIdField] : null}
              filterBy={detailGrid.filterBy ? detailGrid.filterBy(this) : () => {}}
              insideCustomForm={true}
              listenData={detailGrid.listenData}
              listenForm={detailGrid.listenForm}
            />
          </div>
        }

        {p.subforms && p.subforms.map((sf, i) => {
          const detailGrid = sf.detailGrid ? sf.detailGrid() : null
          return (
            <CustomModal
              isOpen={this.state.flags['subformOpen' + i]}
              toggle={() => { this.toogleSubForm(i) }}
              backdrop={'static'}
              wrapClassName={'modal-right'}
              size={sf.size?? 'lg'}
              key={i}
            >
              <ModalHeader toggle={() => { this.toogleSubForm(i) }}>
                {L[sf.name]?? sf.name}
              </ModalHeader>
              <ModalBody>
                {(sf.fields || sf.buttons) &&
                  <FormSmart
                    fields={sf.fields}
                    buttons={sf.buttons}
                    getUrl={sf.getUrlF ? sf.getUrlF(this) : sf.getUrl}
                    postUrl={sf.postUrlF ? sf.postUrlF(this) : sf.postUrl}
                    remapGET={sf.remapGET || null}
                    onSuccess={sf.onSuccess ? (s) => { if (sf.autoClose) this.toogleSubForm(i); sf.onSuccess(s) } : () => { }}
                    onError={sf.onError ? (e) => { sf.onError(e) } : () => { }}
                    remap={sf.remap}
                    wrapClassName={sf.wrapClassName}
                  />
                }

                {detailGrid && (detailGrid.renderIf ? detailGrid.renderIf(this) : true)  &&
                  <CrudGrid
                    module={detailGrid.module }
                    config={detailGrid.config}
                    embeded={detailGrid.embeded}
                    match={{ path: '/app/' + detailGrid.module }}
                    parentId={detailGrid.parentIdField ? this.state[detailGrid.parentIdField] : null}
                    filterBy={detailGrid.filterBy ? detailGrid.filterBy(this) : () => {}}
                    insideCustomForm={true}
                  />
                }
              </ModalBody>
              <ModalFooter>
                <Button outline color="secondary" size="sm" onClick={() => { this.toogleSubForm(i) }}>{'Cerrar'}</Button>
              </ModalFooter>
            </CustomModal>
          )
        })}

        {p.subGrids && p.subGrids.map((g, i) => {
          return (
            <CustomModal isOpen={this.state.flags['subGridOpen' + i]} toggle={() => { this.toogleSubGrid(i) }} backdrop={'static'} wrapClassName={'modal-right'} size="lg" key={i}>
              <ModalHeader toggle={() => { this.toogleSubGrid(i) }}>
                {g.name ? g.name(this) : ''}
              </ModalHeader>
              <ModalBody>
                <CrudGrid
                  match={{ path: '/app/' + g.module }}
                  filterBy={this.state.flags['subGridOpen' + i] ? g.filterBy(this) : () => {} }
                  insideCustomForm={true}
                />
              </ModalBody>
              <ModalFooter>
                <Button outline color="secondary" size="sm" onClick={() => { this.toogleSubGrid(i) }}>{'Cerrar'}</Button>
              </ModalFooter>
            </CustomModal>
          )
        })}

        {this.state.selectedField && <AiAssist field={this.state.selectedField} editor={this.editor} ctxForm={this} L={L} ref={this.aiAssistRef}/>}
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale }
}

export default connect(mapStateToProps, { setLoader })(FormCustom)